import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { SectionHeading } from "@/components/site/SectionHeading";
import { webPageScript } from "@/lib/webpage-jsonld";

export const Route = createFileRoute("/disclaimer")({
  head: () => ({
    meta: [
      { title: "Disclaimer | Online Tax VAT Bangladesh" },
      { name: "description", content: "Disclaimer for Online Tax VAT Bangladesh — information on our website is for general consultancy purposes and not a substitute for professional advice." },
      { property: "og:title", content: "Disclaimer — Online Tax VAT Bangladesh" },
      { property: "og:description", content: "General informational disclaimer for Online Tax VAT Bangladesh." },
      { property: "og:url", content: "https://onlinetaxvat.com/disclaimer" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://onlinetaxvat.com/disclaimer" }],
    scripts: [webPageScript({
      path: "/disclaimer",
      name: "Disclaimer — Online Tax VAT Bangladesh",
      description: "General informational disclaimer for Online Tax VAT Bangladesh.",
    })],
  }),
  component: DisclaimerPage,
});

function DisclaimerPage() {
  return (
    <SiteShell>
      <section className="container-page py-12">
        <SectionHeading eyebrow="Legal" title="Disclaimer" description="Last updated: 25 July 2026" />
        <article className="prose prose-slate dark:prose-invert mt-8 max-w-3xl">
          <p>
            The information provided on <strong>Online Tax VAT Bangladesh</strong> (the "Website") is for general informational and consultancy purposes only. While we make every effort to keep the information up-to-date and accurate in accordance with the laws of Bangladesh (including NBR guidelines), we make no representations or warranties of any kind about the completeness, accuracy, or reliability of the website content.
          </p>
          <p>
            Any reliance you place on such information is therefore strictly at your own risk. Tax laws and regulations are subject to change. For specific legal or financial advice regarding your tax files, always consult directly with our professional tax advisors.
          </p>
          <h2>Related</h2>
          <ul>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/terms">Terms of Use</Link></li>
            <li><Link to="/contact">Contact our team</Link></li>
          </ul>
        </article>
      </section>
    </SiteShell>
  );
}
